module.exports = __webpack_public_path__ + "resources/img/logo_toast.5b46ef3c495d29031174832dd1b2a704.png";